import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button, F0Checkbox } from '@factorialco/f0-react'
import { Sort } from '@factorialco/f0-react/icons/app'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { useOrderEmployees } from 'modules/shift_management/hooks/useOrderEmployees'

enum SortOptions {
  FirstName = 'first_name',
  LastName = 'last_name',
  Seniority = 'seniority',
  Job = 'job',
}

enum SortDirections {
  Asc = 'asc',
  Desc = 'desc',
}

interface SortEmployeesOptionsProps {
  isCheckboxEnabled: boolean
  isChecked: boolean
  onClick: () => void
}

const SortEmployeesOptions = ({
  isCheckboxEnabled,
  isChecked,
  onClick,
}: SortEmployeesOptionsProps) => {
  const [localStorageOrderBy, setLocalStorageOrderBy] = useLocalStorage<string>(
    LOCAL_STORAGE_KEYS.orderEmployeesShiftManagementBy,
    ''
  )
  const [localStorageOrderDir, setLocalStorageOrderDir] = useLocalStorage<string>(
    LOCAL_STORAGE_KEYS.orderEmployeesShiftManagementDir,
    ''
  )
  const { onOrderEmployees } = useOrderEmployees()

  const orderByFirstNameAsc = i18n.t(
    'shift_management.actions.sort_employees.order_by_first_name_asc'
  )
  const orderByFirstNameDesc = i18n.t(
    'shift_management.actions.sort_employees.order_by_first_name_desc'
  )
  const orderByLastNameAsc = i18n.t(
    'shift_management.actions.sort_employees.order_by_last_name_asc'
  )
  const orderByLastNameDesc = i18n.t(
    'shift_management.actions.sort_employees.order_by_last_name_desc'
  )
  const orderBySeniorityAsc = i18n.t(
    'shift_management.actions.sort_employees.order_by_seniority_asc'
  )
  const orderBySeniorityDesc = i18n.t(
    'shift_management.actions.sort_employees.order_by_seniority_desc'
  )
  const orderByJobPositionAsc = i18n.t(
    'shift_management.actions.sort_employees.order_by_job_position_asc'
  )
  const orderByJobPositionDesc = i18n.t(
    'shift_management.actions.sort_employees.order_by_job_position_desc'
  )

  const onClickMenu = (e: MouseEvent) => {
    e.stopPropagation()
  }

  const refreshInfoShiftsRows = (orderBy: string, orderDir: string) => {
    setLocalStorageOrderBy(orderBy)
    setLocalStorageOrderDir(orderDir)
    onOrderEmployees(orderBy, orderDir)
  }

  const orderOptions = [
    {
      label: orderByFirstNameAsc,
      action: () => refreshInfoShiftsRows(SortOptions.FirstName, SortDirections.Asc),
    },
    {
      label: orderByFirstNameDesc,
      action: () => refreshInfoShiftsRows(SortOptions.FirstName, SortDirections.Desc),
    },
    {
      label: orderByLastNameAsc,
      action: () => refreshInfoShiftsRows(SortOptions.LastName, SortDirections.Asc),
    },
    {
      label: orderByLastNameDesc,
      action: () => refreshInfoShiftsRows(SortOptions.LastName, SortDirections.Desc),
    },
    {
      label: orderBySeniorityAsc,
      action: () => refreshInfoShiftsRows(SortOptions.Seniority, SortDirections.Asc),
    },
    {
      label: orderBySeniorityDesc,
      action: () => refreshInfoShiftsRows(SortOptions.Seniority, SortDirections.Desc),
    },
    {
      label: orderByJobPositionAsc,
      action: () => refreshInfoShiftsRows(SortOptions.Job, SortDirections.Asc),
    },
    {
      label: orderByJobPositionDesc,
      action: () => refreshInfoShiftsRows(SortOptions.Job, SortDirections.Desc),
    },
  ]

  return (
    <Box flexDirection="row" width="full" alignItems="center" gap="s0">
      <Box
        flexDirection="row"
        data-testid="menu-order"
        alignItems="center"
        style={{
          opacity: isCheckboxEnabled ? '1' : '0',
          transform: 'scale(0.8)',
          transition: 'opacity .1s ease-in-out',
        }}
      >
        <F0Checkbox checked={isChecked} onCheckedChange={onClick} />
      </Box>
      <Box flexDirection="row" width="full">
        <Text size="200" weight="medium" className="text-f1-foreground-secondary">
          {i18n.t('common.employees')}
        </Text>
      </Box>

      <Box flexDirection="row" justifyContent="flexEnd" onClick={(event) => onClickMenu(event)}>
        <PopoverMenu type="list">
          <PopoverMenu.Trigger>
            <Box width="full" alignItems="flexEnd" paddingY="s2" onClick={onClickMenu}>
              <F0Button
                hideLabel
                variant="ghost"
                size="sm"
                icon={Sort}
                label={i18n.t('shift_management.actions.sort')}
              />
            </Box>
          </PopoverMenu.Trigger>
          <PopoverMenu.Content side="bottom" align="end" width="s200">
            {orderOptions.map(({ label, action }) => (
              <PopoverMenu.TouchableOption key={label} onClick={action} title={label} />
            ))}
          </PopoverMenu.Content>
        </PopoverMenu>
      </Box>
    </Box>
  )
}

export default SortEmployeesOptions
